export const screens = [
    {
        col: 1,
        row: 1,
        total: 1,
    },
    {
        col: 1,
        row: 2,
        total: 2,
    }
]